import { create } from 'zustand';
import { orderCancellationAnalyticsService } from '../api/orderCancellationAnalyticsService';
import { RequestStatus } from '@/shared/model/requestStatus';
import { getErrorMessage } from '@/shared/lib/errors';
import type { OrderCancellationAnalyticsData, OrderCancellationAnalyticsState } from './types';

const initialState: OrderCancellationAnalyticsData = {
    orders: [],
    allCount: 0,
    status: RequestStatus.Idle,
    error: null,
};

let revision = 0;

/** Хранит актуальную страницу аналитики отменённых заказов */
export const useOrderCancellationAnalytics = create<OrderCancellationAnalyticsState>((set) => ({
    ...initialState,

    fetchList: async (request) => {
        const current = ++revision;

        set({
            status: RequestStatus.Loading,
            error: null
        });

        try {
            const response = await orderCancellationAnalyticsService.getList(request);

            if (current !== revision) return;

            set({
                orders: response.orders ?? [],
                allCount: response.allCount ?? 0,
                status: RequestStatus.Success,
            });
        } catch (error: unknown) {
            if (current !== revision) return;

            set({
                status: RequestStatus.Error,
                error: getErrorMessage(error, 'Не удалось загрузить отменённые заказы'),
            });
        }
    },

    clear: () => {
        revision += 1;
        set(initialState);
    },
}));
